import * as React from 'react'

type QuerySelectorReturn = Element | null
type AnyElement = QuerySelectorReturn | QuerySelectorReturn[] | NodeListOf<HTMLElement>

export function useToggleStaticElements(elementToHide?: AnyElement, elementToShow: AnyElement = [], enabled = true) {
  React.useEffect(() => {
    if (!elementToHide) return

    const hideElement = (element?: QuerySelectorReturn) => element?.classList.add('hidden')
    const showElement = (element?: QuerySelectorReturn) => element?.classList.remove('hidden')
    const toggleElements = (element: AnyElement | undefined, toggleFn: typeof hideElement) => {
      if (element instanceof NodeList || Array.isArray(element)) {
        element.forEach(toggleFn)
      } else {
        toggleFn(element)
      }
    }

    toggleElements(elementToHide, enabled ? hideElement : showElement)
    toggleElements(elementToShow, enabled ? showElement : hideElement)

    return () => {
      toggleElements(elementToHide, showElement)
      toggleElements(elementToShow, hideElement)
    }
  }, [elementToHide, elementToShow, enabled])
}
